import content from './content/why-us.json';

export const whyUsMock = {
  name: 'why-us',
  layoutType: 1,
  areasList: [
    {
      id: 'why-us-main',
      componentName: 'Comp:WhyUsPage',
      content: JSON.stringify(content)
    }
  ]
};
